// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Timer_countdown__agN3U","skeleton":"Timer_skeleton__0994x"};